/* eslint-disable */
import React, { Fragment, useEffect, useState, useRef } from 'react';
import Select, { components } from 'react-select';
import axios from 'axios';
import { Button, Modal, Popover, OverlayTrigger, Dropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from "uuid";
import EditInvoiceModal from './InvoicesModal/EditInvoiceModal';
import { Controller, useForm } from 'react-hook-form';
import { RxCross2 } from 'react-icons/rx';
import { AiOutlineClose, AiOutlineDelete, AiFillInfoCircle } from 'react-icons/ai';
import { BiRightArrowAlt } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import countries from 'countries-list';
import { useTranslation } from 'react-i18next';
import { getInvoiceData } from '../../../redux/auth/authSlice';
import ShowInvoiceDialog from '../../../components/ShowInvoiceDialog';
import EditCustomerDialog from '../../../components/common/EditCustomerDialog';
import Loader from '../../../components/Loader';
import invoiceImg from '../../../assets/img/abc.png';
import Calender from '../../../components/Calender';
import WorkingHoursRow from './WorkingHoursRow';
import OtherArticlesRow from './OtherArticlesRow';
import OtherArticlesOptionsUI from './OtherArticlesOptionsUI';
import InvoiceSummaryModal from './InvoicesModal/InvoiceSummaryModal';
import WorkDatesNotificationModal  from './InvoicesModal/WorkDatesNotificationModal'
import RootRutModal from './InvoicesModal/RootRutModal';
import {
  HourlyWages,
  costAgreement,
  costPerDay,
  costPerMonth,
  costPerWeek,
  otherCost,
} from '../../../utils/stringUtils';
import WorkingTimeInfoModal from '../invoice-tool/InvoicesModal/WorkingTimeInfoModal';
import {
  formatDateStr,
  compareInvoicesHours,
  getOtherArticlesUnit,
  calculateTotalSum,
  calculateExpenditureSum,
  diffInDates,
  getArticleNumber,
  isArticleTaxFree,
  getArticleIndividualAmount,
  convertFileToBase64,
  calculateAmountInSelectedCurrency,
  calculateTotalFileSize,
  getArticleNames,
  formatDate,
} from '../../../utils/commonFunc';
import { Alert } from '@mui/material';
import HowCalculatedModal from './HowCalculatedModal';
import InvoiceCreatedModal from './InvoiceCreatedModal';
import OtherArticlesForm from './OtherArticlesForm';
import { AMOUNT_PER_UNIT, ARTICLE_NUMBERS, NEW_ARTICLES, InvoiceToolVersion } from 'src/utils/constants';
import { INVOICE_DESCRIPTION_ALLOWED_CHARACTERS, handleInvoicingDescriptionChange } from 'src/utils/invoicingUtils';
import { handleRemoveFreelancers } from './utils/HandleRemoveFreelancer';
import { onEditArticleForms } from './utils/ArticleFormHandlers';
import AmountInputWithTooltip from './utils/AmountInputWithTooltip'
import InvoiceOffers from './InvoicesComponents/InvoiceOffers'
import CloseInvoiceToolModal from './InvoicesModal/CloseInvoiceToolModal'
import CurrencyDetailsModal from './InvoicesModal/CurrencyDetailsModal'
import VatDetailsModal from './InvoicesModal/VatDetailsModal'
import { fetchCustomer } from './services/UserService';
import { addNewCustomers } from './services/AddNewCustomer';
import { onEditCustomers } from './services/EditCustomer';
import { fetchInvoiceCalculations } from './utils/FetchInvoiceCalculations';
import { updateInvoices } from './utils/UpdateInvoices';
import {requiredFlags } from './constant/RequiredFlags';
import CustomerSection from './InvoicesComponents/CustomerSection'
import { prefillData } from './utils/PrefillData';
import DropdownIndicator from './InvoicesComponents/DropdownIndicator'
import Option from './InvoicesModal/Option.jsx';
import {  processFileItems } from './utils/InvoiceTools';
import {minAmounts} from './constant/MinAmounts'
import {errorKey} from './constant/ErrorKey'
import ExpressPaymentModal from './InvoicesModal/ExpressPaymentModal'

const InvoiceTool = () => {
  const location = useLocation();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [storedValues, setStoredValues] = useState({});

  useEffect(() => {
    if (location.state?.invoiceDetails) {
      setInvoiceDetails(location.state.invoiceDetails);
      setIsEditModalOpen(true);
    }
  }, [location.state]);

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    navigate(`/dashboard/invoices`);
  };

  const { t } = useTranslation();
  const pensionOptions = [1000, 1500, 2000, 2500, 3000];
  // ---------------------------------useForm-------------------------------------
  const {
    reset,
    watch,
    trigger,
    control,
    setValue,
    register,
    setFocus,
    getValues,
    unregister,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      vat: 25,
      travel: 0,
      allowance: 0,
      currency: 'SEK',
      showDates: 'true',
      defaultAmount: [500],
      defaultHours: [8],
    },
  });

  const [customer, setCustomer] = useState({});
  const [grossSalary, setGrossSalary] = useState(0);
  const [article, setArticle] = useState({});
  const [articles, setArticles] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [callUse, setCallUse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [pensionFee, setPensionFee] = useState(5);
  const [pensionAmount, setPensionAmount] = useState(1000)
  const [holidaySavingFee, setHolidaySavingFee] = useState(12);
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [totalHours, setTotalHours] = useState([0]);
  const [showModal, setShowModal] = useState(false);
  const [approvelDate, setApprovelDate] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [callUseEffect, setCallUseEffect] = useState(0);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showRootRut, setShowRootRut] = useState(false);
  const [selectedList, setSelectedList] = useState([{}]);
  const [showReadMore, setShowReadMore] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showAgreement, setShowAgreement] = useState(false);
  const [getCalculations, setGetCalculations] = useState(false);
  const [getErrorMessages, setgetErrorMessages] = useState(null);
  const formattedText = getErrorMessages?.split(/,\s*\*\s*|\*\s*/);

  const [articleAmountHourlyWages, setArticleAmountHourlyWages] = useState(0);

  const [showExpressPayment, setShowExpressPayment] = useState(false);
  const [showWorkDatesNotification, setShowWorkDatesNotification] = useState(null);
  const [previousSelectedFreelancers, setPreviousSelectedFreelancers] = useState([]);
  const [isCollective, setCollective] = useState(false);
  const [isPensionDrop, setPensionDrop] = useState(false);
  const [isHolidaySavingDrop, setHolidaySavingDrop] = useState(false);

  const [pdfError, setPdfError] = useState(null);
  const [searchParams] = useSearchParams();
  const isEditMode = searchParams.get('edit') === 'true';
  const [otherValuesChanged, setOtherValuesChanged] = useState(false);
  const [otherArticlesUI, setOtherArticlesUI] = useState({});
  const [allowancePerDay, setAllowancePerDay] = useState(0);

  const [show, setShow] = useState({
    data: {},
    PDFData: [],
    show: false,
    indexValue: 0,
    invoiceData: {},
    selectedUser: {},
    showVatDetails: false,
    showCalculations: false,
    showCurrencyDetails: false,
    showFreelancerSelect: false,
  });

  const uploadedPDFData = Array.from(show?.PDFData)
  const filterUploadedPDFData = uploadedPDFData?.map((item) => item[0])

  const [unitDateStr, setUnitDateStr] = useState({
    value: 0,
    dateStr: [],
    indexValue: null,
  });

  const [calculatedAmounts, setCalculatedAmounts] = useState({
    net: 0,
    tax: 0,
    amount: 0,
  });

  const [seperatedUserCalculations, setSeperatedUserCalculations] = useState([
    {
      net: 0,
      tax: 0,
      amount: 0,
    },
  ]);
  const [isSeparatelyShown, setIsSeparatelyShown] = useState(false);
  const [userInvoiceData, setUserInvoiceData] = useState([]);
  const [allowancePerDaySweden, setAllowancePerDaySweden] = useState({
    allowance_in: 0,
    allowance_out: 0
  });
  const [dueDate, setDueDate] = useState(null);
  const dueDateInputRef = useRef(null);


  const prefillingData = useSelector((state) => state?.auth);
  const invoiceCreatedUserId = useSelector((state) => state?.createdInvoiceUserData)?.data?.userId;

  const dispatch = useDispatch();

  const [showTooltipError, setShowTooltipError] = useState({
    nullPDF: false,
    nullUnit: false,
    LessAmount: false,
    LessAmountEUR: false,
    LessAmountUSD: false,
    LessAmountGBP: false,
    LessAmountCHF: false,
    LessAmountCAD: false,
    LessAmountAUS: false,
    LessAmountNOK: false,
    LessAmountDKK: false,
    LessAmountJPY: false,
    LessAmountCNY: false,
    NullAmount: false,
    invalidUnit: false,
    NullCustomer: false,
    negativeHours: false,
    inputZeroValue: false,
    inputGreater24Value: false,
    negativeAmount: false,
    noDateSelected: false,
    notOfFixedPrice: false,
    inputNegatieveValue: false,
    selectedFreelancerLimit: false,
    travelAllowanceLessValue: false,
    travelAllowanceGraterValue: false,
  });

  const initializeState = () => {
    const state = {};
    for (let i = 0; i <= 15; i++) {
      state[i] = [];
    }
    return state;
  };

  const [dates, setDates] = useState(initializeState());
  const [otherArticlesData, setOtherArticlesData] = useState(initializeState());

  const [removeClickedDate, setRemoveClickedDate] = useState({
    dateStr: 0,
    indexValue: 0,
  });
  const [countriesList, setCountriesList] = useState([]);

  const [selectedTab, setSelectedTab] = useState({
    index: 0,
    date: '',
    validateUnit: false,
    validateAmount: false,
    validatePdfFile: false,
    validateArticle: false,
    validateCalender: false,
  });

  // -----------------------------------useSelector-----------------------------------

  const selectRef = useRef(null);
  const navigate = useNavigate();
  const { id: userID } = useParams();
  const renderAfterCalled = useRef(false);

  const [freelancers, setFreelancers] = useState([]);

  const globalData = useSelector((state) => state?.globalData?.data);
  const user = useSelector((s) => s?.auth?.user);

  const isBooked = prefillingData?.getInvoiceData?.fetchInvoices?.isBooked || 
                   prefillingData?.getInvoiceData?.isBooked || 
                   false;
  const closeInvoiceTool = () => {
    setShowModal(false);
    dispatch(getInvoiceData({}));
    navigate('/dashboard/app');
  };

  // -----------------------------------register-----------------------------------

  const amountFieldRegister = register('amount');
  // -----------------------------------watch-----------------------------------

  const vat = watch('vat');
  const house = watch('house');
  const amount = watch('amount');
  const travel = watch('travel');
  const pension = watch('pension');
  const isFixed = watch('isFixed');
  const currency = watch('currency');
  const apartment = watch('apartment');
  const allowance = watch('allowance');
  const invoiceFile = watch('invoiceFile');
  const rutDeduction = watch('rutDeduction');
  const invoiceHours = watch('invoiceHours');
  const rootDeduction = watch('rootDeduction');
  const expressPayout = watch('expressPayout');
  const holidaySavings = watch('holidaySavings');
  const selectedFreelancers = watch('freelancer');
  const selectedCustomer = watch('selectedCustomer');
  const showDates = watch('showDates');

  const currencyGlobalValue = globalData?.currencies?.find(
    (item) => item.description === currency
  )?.globalValue;

  const otherArticlesSum = Number(calculateTotalSum(otherArticlesData, currencyGlobalValue));
  const expenditureSum = Number(calculateExpenditureSum(otherArticlesData));
  const [initialInvoiceHours, setInitialInvoiceHours] = useState(invoiceHours);
  // ---------------------------------addNewCustomer-------------------------------------

  const handleEdit = (item) => {
    if (isBooked) return; // Prevent editing when invoice is booked
    setOtherArticlesUI({
      show: true,
      item,
      edit: true,
    });
  };

  const onSubmitArticleForm = (data, calculateTotal, calculateTotalInSelectedCurrency) => {
    const { userId } = userDetails;
    setOtherArticlesData((prevData) => {
      const updatedData = { ...prevData };

      const index = selectedTab.index;

      updatedData[index] = updatedData[index] || []; // Create array if it doesn't exist
      updatedData[index].push({
        id: uuidv4(),
        key: otherArticlesUI?.item?.key,
        value: calculateTotal(),
        valueInSelectedCurrency: calculateTotalInSelectedCurrency(),
        userId: index === 0 ? userId : selectedFreelancers[index - 1]?.userId,
        label: otherArticlesUI?.item?.key === NEW_ARTICLES.MATERIAL_VAT && data?.isMaterialExpenseTaxFree === "0" &&
        (!data?.uploadFile || data.uploadFile.length === 0)
        ? getArticleNames(ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF)
        : otherArticlesUI?.item?.label,
        data,
      });
      return updatedData;
    });

    setOtherValuesChanged(true);

    setOtherArticlesUI({
      show: false,
    });
  };

  const onEditArticleForm = onEditArticleForms({
    otherArticlesUI,
    selectedTab,
    setOtherArticlesData,
    setOtherValuesChanged,
    setOtherArticlesUI
  });
  const addNewCustomer = async (values) => {
    await addNewCustomers({
      values,
      t,
      userID,
      setLoading,
      setShowDialog,
      fetchCustomers,
      setCustomers,
    });
  };
  const onEditCustomer = async (values) => {
    await onEditCustomers({
      values,
      t,
      customer,
      setLoading,
      setShow,
      fetchCustomers,
      setCustomer,
    });
  };
  // -----------------------------------fetchCustomers-----------------------------------
  const fetchCustomers = async () => {
    await fetchCustomer(userID, {
      setLoading,
      setCustomers,
      setFreelancers,
      setUserDetails,
    });
  };
  // -----------------------------------fetchArticles-----------------------------------

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/admin/article');
      const filtredArticles = res?.data.filter(
        (article) =>
          article?.articleNumber === HourlyWages ||
          article?.articleNumber === costPerDay ||
          article?.articleNumber === costPerWeek ||
          article?.articleNumber === costPerMonth ||
          article?.articleNumber === costAgreement
      );
      const cloneArticles = [...filtredArticles];
      const indexToRemove = cloneArticles.findIndex((item) => item?.articleNumber === HourlyWages);
      if (indexToRemove !== -1) {
        cloneArticles.splice(indexToRemove, 1); // Remove the element from its current position
        cloneArticles.unshift(filtredArticles[indexToRemove]); // Add the element to the first position
      }
      const customOrder = [HourlyWages, costPerDay, costPerWeek, costPerMonth, costAgreement];

      const customSort = (a, b) => {
        const indexA = customOrder.indexOf(a?.articleNumber);
        const indexB = customOrder.indexOf(b?.articleNumber);
        return indexA - indexB;
      };

      const sortedArticles = cloneArticles.sort(customSort);
      const isV2 = prefillingData?.getInvoiceData?.fetchInvoices?.invoiceToolVersion === InvoiceToolVersion.V2;
      if (isV2) {
        const costAgreementArticle = sortedArticles.find(a => a.articleNumber === costAgreement);
        if (costAgreementArticle) {
          sortedArticles.push({ ...costAgreementArticle, description: 'Payment per unit', isUnitArticle: true });
        }
      }

      setArticles(sortedArticles);
      setLoading(false);
    } catch (err) {
      setArticles([]);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------fetchCustomers--------------------------------------

  function isPensionApplicable(ssn) {
    return typeof ssn === 'string' && ssn.length === 12 && !ssn.endsWith('000');
  }

  useEffect(() => {
    const validUserCalculations = seperatedUserCalculations?.filter(Boolean) || [];
    const isAnyGrossBelowThreshold = validUserCalculations.some(
      item => (item?.grossInSek || 0) + (item?.pensionInSek || 0) < 5000
    );

    // if (isAnyGrossBelowThreshold) {
    //   setValue("pension", false);
    //   setPensionDrop(false);
    // }
  }, [seperatedUserCalculations, setValue]);

  useEffect(() => {
    const initializeData = async () => {
      try {
        setLoading(true);
        setShow((prev) => ({ ...prev, showVatDetails: false }));
        await Promise.all([fetchCustomers(), fetchArticles()]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    initializeData();
  }, [reset]);

  // -----------------------------------Dispatch-----------------------------------
  useEffect(() => {
    if (rootDeduction || rutDeduction) {
      setValue('isFixed', false);
    }
  }, [rootDeduction, rutDeduction]);

  // -----------------------------------invoicecalculations-----------------------------------
  const anyArrayHasValue = Object.values(otherArticlesData)?.some((array) => array.length > 0);
  const hasWorkingHours = Object.values(dates)?.some((array) => array.length > 0);

  useEffect(() => {
    const fetchCalculation = async () => {
      await fetchInvoiceCalculations({
        watch,
        setSpinner,
        otherArticlesData,
        currencyGlobalValue,
        vat,
        pension,
        pensionAmount,
        rutDeduction,
        rootDeduction,
        expressPayout,
        holidaySavings,
        holidaySavingFee,
        globalData,
        currency,
        userID,
        customer,
        selectedCustomer,
        setSeperatedUserCalculations,
        setCalculatedAmounts,
        anyArrayHasValue,
        HourlyWages,
        allowancePerDaySweden,
        selectedTab,
         prefillingData,
         setGrossSalary,
      });
    };
  
    if (
      amount &&
      globalData?.tax?.globalValue &&
      globalData?.fee?.globalValue
    ) {
      fetchCalculation();
    }
  }, [
    getCalculations,
    anyArrayHasValue,
    isSeparatelyShown,
    customers,
    removeClickedDate,
    grossSalary, setGrossSalary
  ]);
  

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setGetCalculations(!getCalculations);
    }, 800);
    return () => clearTimeout(timeoutId);
  }, [
    globalData,
    amount,
    callUse,
    pension,
    currency,
    callUseEffect,
    rutDeduction,
    rootDeduction,
    holidaySavings,
    article,
    pensionFee,
    vat,
    allowance,
    travel,
    otherArticlesSum,
    expressPayout,
    holidaySavingFee,
    pensionAmount
  ]);

  useEffect(() => {
    setOtherArticlesData((prevData) => {
      const updatedData = { ...prevData };
      Object.keys(updatedData).forEach((index) => {
        updatedData[index] = updatedData[index] || [];
        updatedData[index] = updatedData[index].map((item) => {
          const updatedValueInSelectedCurrency = calculateAmountInSelectedCurrency(item, currencyGlobalValue);
          return {
            ...item,
            valueInSelectedCurrency: updatedValueInSelectedCurrency,
          };
        });
      });
      return updatedData;
    });

    setOtherValuesChanged(true);
  }, [currency]);


  // -----------------------------------TotalHours-----------------------------------

  useEffect(() => {
    const invoiceHours = watch('invoiceHours');
    const totalWorkingHours = [];
    if (Array.isArray(invoiceHours) && invoiceHours[0] !== null) {
      invoiceHours?.forEach((allIndex, index) => {
        let total = 0;
        Object.keys(allIndex)?.forEach((date) => {
          const splitDate = date?.split('-');
          const fullDate = `${splitDate[0]}-${splitDate[1]}-${splitDate[2]}`;
          if (new Date(fullDate).getTime() > new Date().getTime()) {
            if (showWorkDatesNotification === null) {
              setApprovelDate({ indexValue: index, dateStr: date });
              if (searchParams?.size === 0) {
                setShowWorkDatesNotification(true);
              }
            }
          }
          total += Number(allIndex[date]?.article?.articleNumber === HourlyWages ? allIndex[date].units : 0);
        });
        totalWorkingHours[index] = total;
      });
    } else {
      setTotalHours([]);
    }
    setTotalHours(totalWorkingHours);
  }, [dates, showWorkDatesNotification, invoiceHours, amount, article, !isFixed, unitDateStr.value]);

  // ----------------------------------Invoice data------------------------------------
  const dependencie = {
    prefillingData,
    searchParams,
    setCustomer,
    reset,
    setPensionFee,
    setPensionAmount,
    setHolidaySavingFee,
    setInitialInvoiceHours,
    setPreviousSelectedFreelancers,
    setSelectedList,
    setDates,
    setShow,
    setOtherArticlesData,
    invoiceCreatedUserId,
    selectRef,
    ARTICLE_NUMBERS,
    NEW_ARTICLES,
    userID,
    setLoading
  };

  useEffect(() => {
    prefillData(dependencie);
  }, [searchParams?.size >= 1]);

  // Initialize due date from prefilling data
  useEffect(() => {
    const apiDueDate = prefillingData?.getInvoiceData?.fetchInvoices?.dueDate || prefillingData?.getInvoiceData?.dueDate;
    if (apiDueDate && !dueDate) {
      setDueDate(apiDueDate);
    }
  }, [prefillingData, dueDate]);
  // ----------------------------------createInvoice------------------------------------

  const handleScroll = () => {
    window.scrollTo(0, 50);
  };

  useEffect(() => {
    handleScroll();
  }, [getErrorMessages]);


  const createInvoice = async (values) => {
    const { userId } = userDetails;
    let readers = [];
    const fileItems = [];
    const totalWorkingDates = [];
    const amountPerFreelancers = [];
    let freelancersPerDate = [];

    // Uploaded pdf File
    values?.invoiceFile?.forEach((item) => {
      if (item instanceof FileList) {
        Array.from(item)?.forEach((file) => {
          fileItems?.push(file);
          const reader = new FileReader();
          const fileReadPromise = new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
          });
          reader.readAsDataURL(file);
          readers.push(fileReadPromise);
        });
      }
    });

    values?.invoiceFile?.forEach((item, index) => {
      if (item?.fileContent || item?.uploadfileForInvoice) {
        fileItems.push({
          fileName: item?.fileName,
          fileContent: item?.fileContent || item?.uploadfileForInvoice,
          filesUploadid: item?.filesUploadid,
          invoiceApprovalId: item?.invoiceApprovalId,
          userId:
            values?.freelancer && values?.freelancer[index - 1] && index !== 0
              ? values?.freelancer[index - 1]?.userId
              : parseInt(userId, 10) || userId,
        });
      }
    });
    const fileBytes = await Promise.all(readers);
    const file = processFileItems(fileItems, fileBytes, values, userId);

    values.invoiceHours?.forEach((items, index) => {
      Object.keys(items)?.forEach((date) => {
        const [year, month, day] = date?.split("-");
        totalWorkingDates.push({
          id: 0,
          workingDate: `${year}-${month}-${day}`,
          dateId: date,
          number: items[date].units,
          unit: items[date].article.unit,
          amountPerUnit: items[date].amount,
          amount: items[date].amount * items[date].units,
          articleNumber: items[date].article?.articleNumber,
          vat: vat,
          isArticleShownInInvoice: true,
          workingDescription: items[date].workingDescription || "",
          houseworkType: items[date].houseworkType
            ? items[date].houseworkType.value
            : "",
          userId:
            values?.freelancer && values?.freelancer[index - 1] && index !== 0
              ? values?.freelancer[index - 1]?.userId
              : parseInt(userId, 10) || userId,
          workingHour:
            items[date].article?.articleNumber === HourlyWages
              ? items[date].units
              : 0,
          isUnitArticle: items[date].article?.isUnitArticle || false,
        });
      });
    });

    if (anyArrayHasValue) {
      for (const [key, value] of Object.entries(otherArticlesData)) {
        if (value?.length > 0) {
          for (const [index, item] of value.entries()) {
            let date;
            if (item.key === NEW_ARTICLES.MILEAGE) {
              date = item?.data?.travelDate;
            } else if (item.key === NEW_ARTICLES.TRAVEL) {
              date = item?.data?.travelExpDate;
            } else if (item.key === NEW_ARTICLES.MATERIAL_VAT) {
              date = item?.data?.dateOfPurchase;
            }

            let fileBase64 = null;
            if (item.data?.uploadFile) {
              if (item.data?.uploadFile?.[0] instanceof File) {
                try {
                  fileBase64 = await convertFileToBase64(item.data.uploadFile[0]);
                } catch (error) {
                  toast.error("One or more uploaded files could not be processed. Please try again.");
                  setLoading(false);
                  return;
                }
              } else if (typeof item.data?.uploadFile === "string") {
                fileBase64 = item.data.uploadFile;
              }
            } else if (item.data?.fileContent) {
              fileBase64 = item.data.fileContent;
            }

            const parseValue = (value, defaultValue = 0) =>
              isNaN(parseFloat(value)) ? defaultValue : Number(value);

            const currencyFactor = parseValue(currencyGlobalValue, 1);

            let amountPerUnit = 0;

            if (item.key === NEW_ARTICLES.MILEAGE) {
              amountPerUnit = AMOUNT_PER_UNIT.MILEAGE  / currencyFactor;
            } else if (item.key === NEW_ARTICLES.ALLOWANCE_OUT || item.key === NEW_ARTICLES.ALLOWANCE_IN) {
              const allowancePerDay = item?.data?.allowancePerDay || item?.data?.amountPerUnitSek || allowancePerDaySweden[item?.key];
              amountPerUnit = parseValue(allowancePerDay) / currencyFactor;
            } else {
              amountPerUnit = (isNaN(parseFloat(item?.value)) ? 0 : Number(item?.value)) / currencyFactor;
            }

            const isPdfAttachedToInvoice =
            (item?.data?.isMileagePdfShowToCustomer === "1" &&
              item?.data?.isAisPdfShowToCustomer === "1" &&
              item?.data?.isAosPdfShowToCustomer === "1" &&
              item?.data?.isTravelPdfShowToCustomer === "1" &&
              item?.data?.isMaterialPdfShowToCustomer === "1" ) || item?.data?.isPdfAttachedToInvoice;

              const isMileage = item.key === NEW_ARTICLES.MILEAGE;
              const isAllowance = item.key === NEW_ARTICLES.ALLOWANCE_OUT || item?.key === NEW_ARTICLES.ALLOWANCE_IN;

              const amountPerUnitSek = isMileage
                ? AMOUNT_PER_UNIT.MILEAGE
                : isAllowance
                 ? item?.data?.allowancePerDay || item?.data?.amountPerUnitSek || allowancePerDaySweden[item?.key]
                : Number(item?.value);

                const number = isMileage
                ? item?.data?.distance
                : isAllowance
                ? diffInDates(
                    item?.key,
                    item?.data?.tripEndedDateIs || item?.data?.tripEndedDate,
                    item?.data?.tripStartedDateIs || item?.data?.tripStartedDate,
                    item?.data?.tripEndedDateOs || item?.data?.tripEndedDate,
                    item?.data?.tripStartedDateOs || item?.data?.tripStartedDate
                  )
                : "1"

            totalWorkingDates.push({
              id: 0,
              workingDate:date ? date : item?.data?.workingDate?.split("T")?.[0],
              dateId: item?.id,
              number: number,
              unit: getOtherArticlesUnit(item, "unit"),
              amountPerUnitSek:
                amountPerUnitSek,

              amountPerUnit: amountPerUnit,
              articleNumber: getArticleNumber(item),
              workingDescription: item?.label,
              houseworkType: "",
              workingHour: 0,
              isTaxFreeArticle: isArticleTaxFree(item),
              isArticleShownInInvoice:
              requiredFlags.every((flag) => item.data?.[flag] === "1") || item?.data?.isArticleShownInInvoice,
              isPdfAttachedToInvoice: isPdfAttachedToInvoice,
              tripStartedPlace: item?.data?.tripStartedPlace,
              tripEndedPlace: "",
              distance: item?.data?.distance || 0,
              country:
                item?.key === NEW_ARTICLES.ALLOWANCE_OUT
                  ? item?.data?.country
                  : item?.key === NEW_ARTICLES.ALLOWANCE_IN
                  ? "Sweden"
                  : "",
              allowancePerDay: 0,
              reasonForTrip: item?.data?.reasonForTrip || "",
              carRegistrationNo: item?.data?.carRegistrationNo || "",
              vat: item?.data?.vat != null ? Number(item?.data?.vat) : vat,
              tripStartedDate:
                item?.data?.tripStartedDate?.split('T')[0] ||
                (item?.key === NEW_ARTICLES.ALLOWANCE_OUT
                  ? item?.data?.tripStartedDateOs :
                  item?.data?.tripStartedDateIs)
                 ,
              tripEndedDate:item?.data?.tripEndedDate?.split('T')[0] ||
                (item?.key === NEW_ARTICLES.ALLOWANCE_OUT
                  ? item?.data?.tripEndedDateOs : item?.data?.tripEndedDateIs),
                  amount: isNaN(parseFloat(item?.valueInSelectedCurrency))
                  ? 0.0
                  : Number(item?.valueInSelectedCurrency),
              totalDayOfTravels: diffInDates(
                item?.key,
                item?.data?.tripEndedDateIs || item?.data?.tripEndedDate,
                 item?.data?.tripStartedDateIs || item?.data?.tripStartedDate,
                 item?.data?.tripEndedDateOs || item?.data?.tripEndedDate,
                 item?.data?.tripStartedDateOs || item?.data?.tripStartedDate
              ),
              allowanceDestination: item?.data?.destination || item?.data?.allowanceDestination || "",
              expenseCategory: "",
              foodAllowance:item?.data?.totalFoodRate || 0,
              fileName: item.data?.uploadFile?.[0]?.name || item.data?.fileName || null,
              fileContent: fileBase64 ? fileBase64 : null,
              userId:
              item?.userId,
              amountInSek: Number(item?.value),
              isHalfDay: item?.data?.isHalfDay
            });
          }
        }
      }
    }

    let invoiceFreelancer;

    if (!values?.isFixed) {
      if (values.freelancer && values.freelancer?.length) {
        invoiceFreelancer = values.freelancer?.map((item) => ({
          amount: 0,
          userId: item.userId,
        }));
        // If logged-in user is not included
        const isInvoiceCreatorIncluded = values.freelancer?.some((freelancer) => freelancer.userId === userID);
        if (!isInvoiceCreatorIncluded) {
          invoiceFreelancer.push({
            amount: 0,
            userId: Number(userID),
          });
        }
      } else {
        invoiceFreelancer = [
          {
            amount: 0,
            userId: Number(userID),
          },
        ];
      }
    } else {
      if (values.freelancer && values.freelancer?.length) {
        invoiceFreelancer = values.freelancer?.map((item, index) => ({
          amount: amountPerFreelancers[index + 1] || 0,
          userId: item.userId,
        }));
        // If logged-in user is not included
        const isInvoiceCreatorIncluded = values.freelancer?.some((freelancer) => freelancer.userId === userID);
        if (!isInvoiceCreatorIncluded) {
          invoiceFreelancer.push({
            amount: amountPerFreelancers[0],
            userId: Number(userID),
          });
        }
      } else {
        invoiceFreelancer = [
          {
            amount: Number(values?.amount),
            userId: Number(userID),
          },
        ];
      }
    }
    const approveId = location?.state;
    try {
      setShowSubmit(false);
      setLoading(true);

      const workingDatesFileContent = totalWorkingDates.map((date) =>
        date.fileContent ? { fileContent: date.fileContent } : { fileContent: '' }
      );

      const totalFileSize =
        calculateTotalFileSize(file) + calculateTotalFileSize(workingDatesFileContent);

      if (totalFileSize > 20 * 1024 * 1024) {
        setLoading(false);
        toast.error(t("Please ensure that the total size of all uploaded files does not exceed 20 MB"));
        return;
      }

      let invoiceFreelancerArr = [];
      if (values?.freelancer && values?.freelancer.length > 0) {
        invoiceFreelancerArr = values.freelancer.map((freelancer, idx) => ({
          amount: values?.isFixed
        ? amountPerFreelancers[idx + 1] +
          (Number(values.amount) -
            amountPerFreelancers.reduce((x, y) => x + y, 0)) /
            values.invoiceHours?.length
        : 0,
          userId: freelancer.userId,
          pension: pension && typeof pension === "object" ? pension[idx + 1] : pension,
          pensionAmount: pensionAmount && typeof pensionAmount === "object" ? pensionAmount[idx + 1] : pensionAmount,
          PensionFeePercentage: Array.isArray(seperatedUserCalculations) && seperatedUserCalculations[idx + 1] ? seperatedUserCalculations[idx + 1].pensionPercentage : undefined,
          holidaySavings: values?.holidaySavings && typeof values.holidaySavings === "object" ? values.holidaySavings[idx + 1] : values?.holidaySavings,
          holidaySavingsFee: holidaySavingFee && typeof holidaySavingFee === "object" ? holidaySavingFee[idx + 1] : holidaySavingFee,
        }));
        // Add main user as first element
        invoiceFreelancerArr.unshift({
          amount: values?.isFixed
        ? amountPerFreelancers[0] +
          (Number(values.amount) -
            amountPerFreelancers.reduce((x, y) => x + y, 0)) /
            values.invoiceHours?.length
        : 0,
         userId: userDetails?.userId,
          pension: pension && typeof pension === "object" ? pension[0] : pension,
          pensionAmount: pensionAmount && typeof pensionAmount === "object" ? pensionAmount[0] : pensionAmount,
          PensionFeePercentage: Array.isArray(seperatedUserCalculations) && seperatedUserCalculations[0] ? seperatedUserCalculations[0].pensionPercentage : undefined,
          holidaySavings: values?.holidaySavings && typeof values.holidaySavings === "object" ? values.holidaySavings[0] : values?.holidaySavings,
          holidaySavingsFee: holidaySavingFee && typeof holidaySavingFee === "object" ? holidaySavingFee[0] : holidaySavingFee,
        });
      } else {
        invoiceFreelancerArr = [
          {
        amount: 0,
        userId: 0,
        pension: pension && typeof pension === "object" ? pension[0] : pension,
        pensionAmount: pensionAmount && typeof pensionAmount === "object" ? pensionAmount[0] : pensionAmount,
        PensionFeePercentage: Array.isArray(seperatedUserCalculations) && seperatedUserCalculations[0] ? seperatedUserCalculations[0].pensionPercentage : undefined,
        holidaySavings: values?.holidaySavings && typeof values.holidaySavings === "object" ? values.holidaySavings[0] : values?.holidaySavings,
        holidaySavingsFee: holidaySavingFee && typeof holidaySavingFee === "object" ? holidaySavingFee[0] : holidaySavingFee,
          },
        ];
      }

      // Determine pension value to send: if pension is an object with more than 1 key, send null; else send pension as is
      let pensionToSend = pension;
      if (pension && typeof pension === "object") {
        const keys = Object.keys(pension);
        if (keys.length > 1) {
          pensionToSend = false;
        } else if (keys.length === 1) {
          pensionToSend = pension[0];
        }
      }
      let holidaySavingsToSend = holidaySavings;
      if (holidaySavings && typeof holidaySavings === "object") {
        const keys = Object.keys(holidaySavings);
        if (keys.length > 1) {
          holidaySavingsToSend = false;
        } else if (keys.length === 1) {
          holidaySavingsToSend = holidaySavings[0];
        }
      }
      // let holidaySavingsFeeToSend = holidaySavingFee;
      // if (holidaySavingFee && typeof holidaySavingFee === "object") {
      //   // If it's an array, get the first element; if it's an object, get the value of the first key
      //   if (Array.isArray(holidaySavingFee)) {
      //     holidaySavingsFeeToSend = holidaySavingFee[0];
      //   } else {
      //     const firstKey = Object.keys(holidaySavingFee)[0];
      //     holidaySavingsFeeToSend = holidaySavingFee[firstKey];
      //   }
      // }

       let holidaySavingsFeeToSend = holidaySavingFee;
      if (holidaySavingFee && typeof holidaySavingFee === "object") {
        const keys = Object.keys(holidaySavingFee);
        if (keys.length > 1) {
          holidaySavingsFeeToSend = 0;
        } else if (keys.length === 1) {
          holidaySavingsFeeToSend = holidaySavingFee[0];
        }
      }
      let pensionAmountToSend = pensionAmount;
      if (pensionAmount && typeof pensionAmount === "object") {
        const keys = Object.keys(pensionAmount);
        if (keys.length > 1) {
          pensionAmountToSend = 0;
        } else if (keys.length === 1) {
          pensionAmountToSend = pensionAmount[0];
        }
      }
      // Format due date to ISO string with timezone offset
      const formatDueDate = (dateStr) => {
        if (!dateStr) return dateStr;
        const date = new Date(dateStr + 'T16:15:48');
        return date.toISOString().replace('Z', '+07:00');
      };

      const res = await axios.post("/admin/invoice", {
        approvalInvoiceId: approveId ? approveId : 0,
        rootDeductionAmount: calculatedAmounts?.rootDeductionAmount,
        rutDeductionAmount: calculatedAmounts?.rutDeductionAmount,
        invoiceNumber: 0,
        sendInvoice: 1,
        vat: values.vat,
        pension: pensionToSend,
        amount: parseFloat(values.amount),
        isFixed: values.isFixed,
        currency: values.currency,
        brfNo: values.brfNo || "",
        registerAssignment: false,
        showDates: values.showDates,
        house: values.house || false,
        holidaySavings: holidaySavingsToSend,
        description: values.description,
        taxValue: calculatedAmounts.tax,
        totalToPay: calculatedAmounts.net,
        rutDeduction: values.rutDeduction,
        rootDeduction: values.rootDeduction,
        file: file.length > 0 ? file : null,
        expressPayout: (customer?.paymentTerm == '45' || customer?.paymentTerm == '60' || customer?.accountType === 1 || (customer?.country !== "Sweden" && customer?.accountType !== 1) ) ? false : values?.expressPayout,
        workingHours: [...totalWorkingDates],
        email: values?.selectedCustomer?.email,
        apartment: values.apartment || false,
        pensionFee: pension ? seperatedUserCalculations[0]?.pensionPercentage : 0,
        holidaySavingsFee: holidaySavings ? holidaySavingsFeeToSend : 0,
        tax: parseInt(globalData?.tax?.globalValue, 10),
        rotApartmentNo: values.rotApartmentNo || "",
        pensionAmount: pensionAmountToSend,
        customerId: values.selectedCustomer.customerId,
        expenditureForMaterialsAndToolsTaxFreeAmount: expenditureSum
          ? expenditureSum
          : 0,
        holidaySavingsAmount: calculatedAmounts?.holidayPayAmount,
        amountIncVat: Math.round(calculatedAmounts?.amountIncludingVat),
        secondaryEmailAddress: values.selectedCustomer.secondaryEmailAddress,
        multipleFreelancer:
          values?.freelancer && values?.freelancer.length > 0 ? true : false,
        currencyRate: globalData.currencies?.find(
          (item) => item.description === values.currency
        )?.globalValue,
        createdByAdmin: true,
        createdBy: userID,
        dueDate: formatDueDate(dueDate),
       invoiceFreelancer: invoiceFreelancerArr,
      });

      if (res?.data?.statusCode === 500) {
        toast.error(t("Something went wrong while saving invoice, this invoice has been cancelled. Please try again."));
        setLoading(false);
        return;
      }

      setInvoiceNumber(res?.data.response.invoiceNumber);
      toast.success(t("Invoice created successfully"));
      setLoading(false);
    } catch (err) {
      console.log('error fetching invoice', err);
      handleScroll();
      const errorMessage = err?.response?.data?.message || err?.message || 'Something went wrong, Please try again';
      setgetErrorMessages(errorMessage);
      setShowSubmit(false);
      setLoading(false);

    } finally {
      setShowSubmit(false);
      setLoading(false);
    }
  };

  // ----------------------------------updateInvoice------------------------------------

  const dependencies = {
    invoiceCreatedUserId,
    prefillingData,
    setShowSubmit,
    setLoading,
    toast,
    t,
    navigate,
    calculateTotalFileSize,
    convertFileToBase64,
    diffInDates,
    getOtherArticlesUnit,
    getArticleNumber,
    isArticleTaxFree,
    requiredFlags,
    allowancePerDaySweden,
    AMOUNT_PER_UNIT,
    NEW_ARTICLES,
    globalData,
    calculatedAmounts,
    expenditureSum,
    holidaySavingFee,
    pension,
    holidaySavings,
    vat,
    anyArrayHasValue,
    otherArticlesData,
    seperatedUserCalculations,
    user,
    pensionAmount,
    dueDate,
    userDetails,
  };

  const handleUpdateInvoices = async (values) => {
    await updateInvoices(values, dependencies);
  };

  // --------------------------------SelectCustomer--------------------------------------

  const handleTypeSelect = (value) => {
    const vatValue = (value.accountType === 3 || (value.accountType === 2 && value?.country !== 'Sweden')) ? 0 : 25;
    setValue('vat', vatValue);
    setAccountType(value.accountType);
    setCustomer({ customerId: customer?.customerId, ...value });
    selectRef?.current?.blur();
    setValue('selectedCustomer', { ...value });
    if (customer?.accountType !== 0 || customer?.accountType !== 1) {
      setValue('rootDeduction', false);
      setValue('rutDeduction', false);
    }
  };
  // ---------------------------------OnDateChange-------------------------------------
  const handleChangeDate = () => {
    renderAfterCalled.current = true;
  };

  useEffect(() => {
    if (!invoiceHours && anyArrayHasValue) {
      let totalAmount = 0;
      totalAmount += otherArticlesSum || 0;

      setValue("amount", totalAmount?.toFixed(2));
      setCalculatedAmounts((prevState) => ({
        ...prevState,
        amount: totalAmount?.toFixed(2),
      }));
    }
  }, [anyArrayHasValue, invoiceHours, otherArticlesSum, setValue]);

  useEffect(() => {
    if (renderAfterCalled.current) {
      const invoiceHours = watch("invoiceHours");
      if (!invoiceHours && !anyArrayHasValue) {
        setValue("amount", 0);
        setCalculatedAmounts({
          amount: 0,
          net: 0,
          tax: 0,
        });
      } else {
        let totalAmount = 0, hourlyAmount = 0;

        invoiceHours?.forEach((group) => {
          Object.values(group).forEach(({ article, amount, units }) => {
            const amt = parseFloat(amount || 0);
            const unit = parseFloat(units || 0);
            if (article?.articleNumber === HourlyWages) hourlyAmount += amt * unit;
            totalAmount += amt * unit;
          });
        });

        if (anyArrayHasValue) totalAmount += otherArticlesSum || 0;

        setArticleAmountHourlyWages(hourlyAmount);
        setCallUse(!callUse);
        setValue("amount", totalAmount.toFixed(2));
        setCalculatedAmounts((prev) => ({ ...prev, amount: totalAmount.toFixed(2) }));
      }
    }
  }, [dates, anyArrayHasValue, otherArticlesSum]);
  // ---------------------------------onClickFixedPrice-------------------------------------
  const handleChangeFixedPrice = (event) => {
    const isFixed = event.target.checked;
    const invoiceHours = watch("invoiceHours");

    if (isFixed) {
      setValue("amount", "");
      if (!initialInvoiceHours) {
        setInitialInvoiceHours(JSON.parse(JSON.stringify(invoiceHours)));
      }
      const clearedHours = invoiceHours?.map((group) => ({
        ...group,
        ...Object.fromEntries(
          Object.entries(group).map(([k, v]) => [k, { ...v, amount: "" }])
        ),
      }));
      setValue("invoiceHours", clearedHours);
      return;
    }
    const isSame = compareInvoicesHours(initialInvoiceHours, invoiceHours);
    const updatedHours = isSame ? initialInvoiceHours : invoiceHours;

    setValue("invoiceHours", updatedHours);
    setSelectedIndex(null);

    if (!updatedHours && !anyArrayHasValue) {
      setValue("amount", 0);
      setCalculatedAmounts({ amount: 0 });
      return;
    }

    let totalAmount = 0, hourlyAmount = 0;

    updatedHours?.forEach((group) => {
      Object.values(group).forEach(({ article, amount, units }) => {
        const parsedAmount = parseFloat(amount || 0);
        const parsedUnits = parseFloat(units || 0);
        if (article?.articleNumber === HourlyWages) hourlyAmount += parsedAmount * parsedUnits;
        totalAmount += parsedAmount * parsedUnits;
      });
    });

    if (anyArrayHasValue) totalAmount += otherArticlesSum || 0;

    setArticleAmountHourlyWages(hourlyAmount);
    setCallUse(!callUse);
    setValue("amount", totalAmount.toFixed(2));
    setCalculatedAmounts((prev) => ({ ...prev, amount: totalAmount.toFixed(2) }));
  };

  const prefillFileForInvoiceData = invoiceFile?.map(item => item?.fileContent)?.filter((item) => item !== undefined);

  const combineprefillInvoiceFileData = [filterUploadedPDFData, prefillFileForInvoiceData].flat()

  // ---------------------------------handleChangeInvoiceArticle-------------------------------------
  const handleChangeInvoiceArticle = (e, dateStr, indexValue) => {
    setArticle(e);
   setValue(`invoiceHours[${indexValue}.[${dateStr}].article]`, e);
    const invoiceHours = watch("invoiceHours");
    if (!invoiceHours && !anyArrayHasValue) return;
    const isFixedRate = [costPerDay, costPerWeek, costPerMonth, costAgreement].includes(e?.articleNumber);
    const isHourly = e?.articleNumber === HourlyWages;
    const defaultUnits = isFixedRate ? 1 : isHourly ? 8 : 0;
    setValue(`invoiceHours[${indexValue}].[${dateStr}].units`, defaultUnits);
    setValue(`defaultHours[${indexValue}].hoursPerDay`, defaultUnits);
    let totalAmount = 0;
    let hourlyAmount = 0;
    invoiceHours?.forEach((dayEntries) => {
      Object.values(dayEntries).forEach(({ units = 0, amount = 0, article }) => {
        const parsedUnits = parseFloat(units || 0);
        const parsedAmount = parseFloat(amount || 0);
        totalAmount += parsedUnits * parsedAmount;

        if (article?.articleNumber === HourlyWages) {
          hourlyAmount += parsedUnits * parsedAmount;
        }
      });
    });
    if (anyArrayHasValue) {
      totalAmount += otherArticlesSum || 0;
    }
    setArticleAmountHourlyWages(hourlyAmount);
    setValue("amount", totalAmount.toFixed(2));
    setCalculatedAmounts((prev) => ({
      ...prev,
      amount: totalAmount.toFixed(2),
    }));
  };

  // ---------------------------------ChangeUnit-------------------------------------

  const handleChangeUnit = () => {
    let totalAmount = 0;
    const invoiceHours = watch('invoiceHours');
    if (invoiceHours) {
      invoiceHours?.forEach((allIndex) => {
        Object.keys(allIndex).forEach((date) => {
          if (allIndex[date].units && allIndex[date].amount) {
            totalAmount +=
              parseFloat(
                Number(allIndex[date].units) < 0 || Number.isNaN(allIndex[date].units)
                  ? 0
                  : Number(allIndex[date].units)
              ) * Number(allIndex[date].amount);
          }
        });
      });
    }
    if (!isFixed) {
      setValue('amount', totalAmount?.toFixed(2));
      setCalculatedAmounts((prevState) => ({
        ...prevState,
        amount: totalAmount?.toFixed(2),
      }));
    }
    setCallUseEffect(callUseEffect);
    if (amount === totalAmount) {
      setCallUse(!callUse);
    }
  };

  // ----------------------------------ChangeAmount------------------------------------

  const handleChangeAmount = () => {
    let amounts;
    let totalAmount = 0;
    let hourlyAmount = 0;
    const invoiceHours = watch("invoiceHours");
    if (invoiceHours || anyArrayHasValue) {
      invoiceHours?.forEach((allIndex) => {
        Object.keys(allIndex)?.forEach((date) => {
          amounts = allIndex[date].amount === "";
          if (allIndex[date].units && allIndex[date].amount) {
            if (allIndex[date]?.article?.articleNumber === HourlyWages) {
              hourlyAmount +=
                parseFloat(allIndex[date].amount) *
                parseFloat(allIndex[date].units);
            }
            totalAmount +=
              parseFloat(
                allIndex[date].units === "" ? 0 : allIndex[date].units
              ) *
              parseFloat(
                allIndex[date].amount < 0
                  ? 0
                  : allIndex[date].amount === ""
                    ? 0
                    : Number(allIndex[date].amount)
              );
          }
        });
      });
    }
    if (anyArrayHasValue) {
      totalAmount += otherArticlesSum || 0;
    }
    setArticleAmountHourlyWages(hourlyAmount);

    if (!isFixed) {
      setValue("amount", totalAmount?.toFixed(2));
      setCalculatedAmounts((prevState) => ({
        ...prevState,
        amount: totalAmount?.toFixed(2),
      }));
    }
    if (amount !== totalAmount) setCallUse(!callUse);
  };

  const handleOtherArticleValue = (e, item) => {
    if (isBooked) return; 
    setOtherArticlesUI({
      show: true,
      item,
    });
  };
  const handleTotalAmountChange = (e) => {
    const amount = Number(e.target.value);
    if (amount && currency in minAmounts && amount < minAmounts[currency]) {
      const errorType = errorKey[currency];
      setShowTooltipError({ [errorType]: true });
      setTimeout(() => setShowTooltipError({ [errorType]: false }), 5000);
    }
  };

  useEffect(() => {
    if (isFixed) {
      let totalAmount = 0;
      if (amount) {
        totalAmount = amount - otherArticlesSum;
      }

      let totalUnits = 0;

      invoiceHours?.forEach((item) => {
        Object.values(item).forEach((entry) => {
          totalUnits += Number(entry.units);
        });
      });

      const amountPerUnit = totalAmount / totalUnits;
      // each freelancer gets value after calculation
      invoiceHours?.forEach((item) => {
        Object.values(item).forEach((entry) => {
          entry.amount = amountPerUnit;
        });
      });

      setValue(`invoiceHours`, invoiceHours);
    }
  }, [otherArticlesSum, amount]);
  // -----------------------------------RemoveDate-----------------------------------
  useEffect(() => {
    const { indexValue, dateStr } = removeClickedDate;

    const fieldsToRemove = ['', '.units', '.houseworkType', '.amount', '.article'];
    fieldsToRemove.forEach(field =>
      unregister(`invoiceHours[${indexValue}].${dateStr}${field}`)
    );

    let totalAmount = 0;
    let hourlyAmount = 0;

    if (Array.isArray(invoiceHours) && invoiceHours[0] !== null) {
      invoiceHours.forEach(group => {
        Object.values(group).forEach(({ article, amount, units }) => {
          const parsedAmount = parseFloat(amount || 0);
          const parsedUnits = parseFloat(units || 0);

          if (article?.articleNumber === HourlyWages) {
            hourlyAmount += parsedAmount * parsedUnits;
          }

          totalAmount += parsedAmount * parsedUnits;
        });
      });

      if (hasWorkingHours) setArticle({});
      if (anyArrayHasValue) totalAmount += otherArticlesSum || 0;

      const finalAmount =
        prefillingData?.getInvoiceData?.amount && !otherValuesChanged && removeClickedDate?.dateStr === 0
          ? prefillingData?.getInvoiceData?.amount
          : totalAmount;

      setArticleAmountHourlyWages(hourlyAmount);
      setValue("amount", finalAmount.toFixed(2));
      setCalculatedAmounts(prev => ({ ...prev, amount: finalAmount.toFixed(2) }));
    }
  }, [register, removeClickedDate, otherArticlesData]);

  // ---------------------------------removeUnapprovedDate-------------------------------------

  const removeUnapprovedDate = () => {
    setDates((prevState) => {
      const updatedDates = { ...prevState };

      Object.keys(updatedDates).forEach((item) => {
        updatedDates[item] = updatedDates[item]?.slice(0, -1);
      });

      return updatedDates;
    });

    setRemoveClickedDate({ ...approvelDate });
    setShowWorkDatesNotification(false);
  };

  // -----------------------------------On Submit Amount Validation-----------------------------------
  useEffect(() => {
    if (!renderAfterCalled.current) return;

    const { date, validateAmount, validateUnit, validateArticle, validatePdfFile, index } = selectedTab;

    const showError = (field, key, duration = 3000) => {
      setFocus(field);
      setShowTooltipError({ [key]: true });
      setTimeout(() => setShowTooltipError({ [key]: false }), duration);
    };

    if (!date && !anyArrayHasValue && !hasWorkingHours) {
      return showError(null, 'noDateSelected', 5000);
    }

    const fieldPrefix = `invoiceHours[${index}].[${date}]`;

    if (validateAmount) showError(`${fieldPrefix}.amount`, 'NullAmount');
    else if (validateUnit) showError(`${fieldPrefix}.units`, 'nullUnit');
    else if (validateArticle) setFocus(`${fieldPrefix}.article`);
    else if (validatePdfFile) showError(`invoiceFile[${index}]`, 'nullPDF');
  }, [selectedTab.validateCalender]);

  const handleAmountError = (errorType) => {
    setSelectedIndex(0);
    setFocus(`amount`);
    const errorObject = {};
    errorObject[errorType] = true;
    setShowTooltipError(errorObject);
    setTimeout(() => {
      setShowTooltipError({
        [errorType]: false,
      });
    }, 5000);
  };

  const amountValidation = (calledForShowInvoice) => {
    const invoiceFile = watch("invoiceFile");
    const invoiceHours = watch("invoiceHours");
    const totalAmountVal = parseInt(getValues("amount"));
    const errorTimeout = (key) => {
      setShowTooltipError({ [key]: true });
      setTimeout(() => setShowTooltipError({ [key]: false }), 3000);
    };

    if (!selectedCustomer) {
      selectRef?.current?.focus();
      errorTimeout('NullCustomer');
      return;
    }

    let issue = null;

    selectedList?.forEach((item, i) => {
      if (!invoiceHours?.[i]) issue = { index: i, type: 'noDateSelected' };
    });

    invoiceHours?.forEach((entry, i) => {
      Object.entries(entry || {}).forEach(([date, values]) => {
        if (values.amount === "") issue = { index: i, date, type: 'validateAmount' };
        else if (values.units === "") issue = { index: i, date, type: 'validateUnit' };
        else if (!values.article) issue = { index: i, date, type: 'validateArticle' };
      });
    });

    if (issue) {
      renderAfterCalled.current = true;
      setSelectedTab((prev) => ({
        ...prev,
        index: issue.index,
        date: issue.date || '',
        validateCalender: !prev.validateCalender,
        validateAmount: issue.type === 'validateAmount',
        validateUnit: issue.type === 'validateUnit',
        validateArticle: issue.type === 'validateArticle',
      }));
      return;
    }

    if (amount === '' && isFixed) {
      setFocus('amount');
      errorTimeout('NullAmount');
      return;
    }

    const currencyThresholds = {
      SEK: 100, EUR: 10, USD: 11, GBP: 9,
      CHF: 10, CAD: 15, AUD: 17, NOK: 118,
      DKK: 75, JPY: 1576, CNY: 77,
    };

    if (totalAmountVal < (currencyThresholds[currency] || 0)) {
      handleAmountError(`LessAmount${currency === 'SEK' ? '' : currency}`);
      return;
    }

    calledForShowInvoice ? setShowInvoice(true) : setShowSubmit(true);
  };
  // -----------------------------------See How We Calculated-----------------------------------
  const handleSeeCalculations = async () => {
    const invoiceHours = watch("invoiceHours") || [];

    const totals = {
      hourlyWagesAmount: 0,
      paymentPerDayAmount: 0,
      paymentPerWeekAmount: 0,
      paymentPerMonthAmount: 0,
      paymentAsAgreedAmount: 0,
    };

    const articleMap = {
      [HourlyWages]: "hourlyWagesAmount",
      [costPerDay]: "paymentPerDayAmount",
      [costPerWeek]: "paymentPerWeekAmount",
      [costPerMonth]: "paymentPerMonthAmount",
      [costAgreement]: "paymentAsAgreedAmount",
    };

    const userInvoiceData = invoiceHours.map((items = {}) => {
      const subTotals = {
        hourlyWagesAmount: 0,
        paymentPerDayAmount: 0,
        paymentPerWeekAmount: 0,
        paymentPerMonthAmount: 0,
        paymentAsAgreedAmount: 0,
      };

      Object.values(items).forEach(({ article, units, amount }) => {
        const key = articleMap[article?.articleNumber];
        if (key) {
          const value = article?.articleNumber === HourlyWages ? +units || 0 : +amount || 0;
          subTotals[key] += value;
          totals[key] += value;
        } else {
          amountValidation();
        }
      });

      return subTotals;
    });

    setUserInvoiceData(userInvoiceData);
    setShow((prev) => ({
      ...prev,
      showCalculations: true,
      invoiceData: { ...totals },
    }));
  };

  // ---------------------------------Remove Unselected Freelancer-------------------------------------
  const handleRemoveFreelancer = (previousSelectedFreelancers, currentSelectedFreelancers) => {
    handleRemoveFreelancers({
      previousSelectedFreelancers,
      currentSelectedFreelancers,
      watch,
      unregister,
      reset,
      setRemoveClickedDate,
      setDates,
      setSelectedTab,
      dates,
      vat,
      holidaySavings,
      selectedCustomer,
      setValue,
    });
  }
  // ---------------------------------Handle Freelancer Select-------------------------------------

  const handleFreelancerSelect = (selectedFreelancer, i) => {
    setValue('freelancer', selectedFreelancer);
    const { createdBy, userId, createdDate, isDeleted, updatedDate } = userDetails;
    const loginedUserIndex = selectedFreelancer.findIndex((item) => item?.userId === invoiceCreatedUserId);
    if (loginedUserIndex !== -1) {
      const adjustedList = [...selectedFreelancer]; // Create a copy of the original list

      // Remove the logged-in user from its current position and insert it at the beginning
      const removedItem = adjustedList.splice(loginedUserIndex, 1)[0];
      adjustedList.unshift(removedItem);

      setSelectedList(adjustedList);
    } else {
      setSelectedList([
        {
          userId,
          createdBy,
          createdDate,
          isDeleted,
          updatedDate,
          value: userId,
          signUpUser: { ...userDetails },
        },
        ...selectedFreelancer,
      ]);
    }

    if (i?.removedValue?.userId) {
      setOtherArticlesData((prevData) => {
        const updatedData = { ...prevData };
        const userIdToRemove = i?.removedValue?.userId; // Example userId to remove
        let foundIndex = null;

        // Find the index of the user ID to remove
        for (const key of Object.keys(updatedData)) {
          const currentData = updatedData[key];
          if (currentData.some((item) => item.userId === userIdToRemove)) {
            foundIndex = parseInt(key);
            break;
          }
        }

        // If the user ID is found, shift the data
        if (foundIndex !== null) {
          for (let i = foundIndex; i < Object.keys(updatedData).length - 1; i++) {
            const currentKey = Object.keys(updatedData)[i];
            const nextKey = Object.keys(updatedData)[i + 1];
            updatedData[currentKey] = updatedData[nextKey];
          }

          // Clear the last index
          updatedData[Object.keys(updatedData).length - 1] = [];
        }

        return updatedData;
      });
    }
    setPreviousSelectedFreelancers(selectedFreelancer);
    handleRemoveFreelancer(previousSelectedFreelancers, selectedFreelancer);
  };

  // ---------------------------------Calculation After Unselect Freelancer-------------------------------------

  // ---------------------------------onSubmit-------------------------------------

  const onSubmit = () => amountValidation();
  const descriptionValue = watch('description');

  useEffect(() => {
    let errorMessage = '';

    const descriptionLength = descriptionValue?.length;

    const invalidCharactersInDescription = descriptionValue
      ?.split("")
      ?.filter((char) => !INVOICE_DESCRIPTION_ALLOWED_CHARACTERS.test(char));

    const wordCount = descriptionValue?.trim().split(/\s+/).filter(word => word.length > 0).length || 0;
    if ((descriptionLength > 0 && wordCount < 3 && descriptionLength < 20)) {
      errorMessage = 'Enter at least 3 words or 20 characters';
    } else if (descriptionLength > 1024) {
      errorMessage = "Maximum character limit 1024";
    } else if (invalidCharactersInDescription?.length > 0) {
      errorMessage = `Invalid characters detected: ${invalidCharactersInDescription.join(", ")}`;
    }

    setError('description', {
      message: errorMessage,
    });
  }, [descriptionValue, setError]);

  const getAllowance = async () => {
    try {
      const url = `admin/invoice/foreign-amount-allowance`;
      const result = await axios.get(url);
      if (result?.status === 200) {
        const data = result?.data?.response?.results;
        setCountriesList(data);
      }
    } catch (err) { }
  };
  useEffect(() => {
    getAllowance();
  }, []);

  const allArticlesHaveNumber92 = () => {
    return invoiceHours?.every((item) =>
      Object.values(item).every((article) => article.article?.articleNumber === '92')
    );
  };

  return (
    <div className="invoice-tool py-5">
      {loading && <Loader />}
      <div className="d-flex justify-content-between align-items-center mb-4 px-3">
        <h4 className="mb-0 text-dark main-heading">{t('THE INVOICING TOOL')}</h4>
      </div>

      <div className="m-auto w-50">
        {getErrorMessages && (
          <div className="position-relative mt-1">
            <Alert severity="error">
              <ul>
                {formattedText?.map((text, index) => (
                  <li key={index} className="errorLine" style={{ lineHeight: 2 }}>
                    {text}
                  </li>
                ))}
              </ul>
            </Alert>
            <RxCross2
              onClick={() => setgetErrorMessages(null)}
              style={{
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                right: 0,
                color: 'black',
                fontSize: 18,
              }}
            />
          </div>
        )}

      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="mt-3 row mx-0">
        <div className="col-12 bg-secondary-custom px-3 py-4">
          <h5 className="heading">1 {t('Customer')}</h5>
          <p>{t('Here you specify who the invoice should be sent to.')}</p>
          <div className="row m-0 mb-3 flex-sm-column flex-xs-column flex-md-row">
            <div className="col p-3 bg-white border customer-box abc d-flex flex-column mb-3 justify-content-between">
              <div>
                <div className="d-flex justify-content-between mb-2 flex-column-on-mobile">
                  <h6 className="mb-0">{t('Select a customer')}</h6>
                </div>
                <OverlayTrigger
                  show={!isBooked && showTooltipError.NullCustomer}
                  placement="top"
                  overlay={
                    <Popover id={`popover-positioned-top`} style={{ margin: 0 }}>
                      <Popover.Header className="text-danger" as="h3">
                        {showTooltipError.NullCustomer && t('Select a customer from the list')}
                      </Popover.Header>
                    </Popover>
                  }
                >
                  <div>
                    <Controller
                      control={control}
                      name="selectedCustomer"
                      render={({ field, fieldState }) => (
                        <Select
                          size="lg"
                          {...field}
                          labelKey="name"
                          ref={selectRef}
                          className="mb-3"
                          onChange={handleTypeSelect}
                          selected={field?.value?.name}
                          id="createInvoiceCustomerSelect"
                          isDisabled={isBooked}
                          // menuIsOpen={!loading && openCustomerList}
                          getOptionLabel={(option) => option?.name}
                          menuPortalTarget={document.querySelector('body')}
                          placeholder={t('Select Customer')}
                          options={customers?.map((customer) => ({
                            ...customer,
                            value: customer.customerId,
                          }))}
                          noOptionsMessage={({ inputValue }) => (!inputValue ? t('No options') : t('No results found'))}
                        />
                      )}
                    />
                  </div>
                </OverlayTrigger>
              </div>

              <div>
                <Button 
                  className="mb-3" 
                  onClick={() => {
                    if (isBooked) return;
                    setShowDialog(true);
                  }} 
                  variant="primary"
                  disabled={isBooked}
                  style={{
                    opacity: isBooked ? 0.5 : 1,
                    cursor: isBooked ? 'not-allowed' : 'pointer'
                  }}
                >
                  {t('Add new Customer')}
                </Button>
              </div>
            </div>
            <div className="col p-3 bg-white ml-2 border customer-box2 position-relative mb-3">
              {customer && customer?.email && (
                <CustomerSection
                  customer={customer}
                  show={show}
                  setShow={setShow}
                  accountType={accountType}
                  isBooked={isBooked}
                />
              )}
            </div>
          </div>
          <div>
            {errors.selectedCustomer && (
              <div className="alert alert-danger" role="alert">
                {' '}
                {errors.selectedCustomer.message}
              </div>
            )}
          </div>
          <Button 
            variant="primary" 
            onClick={() => {
              if (isBooked) return;
              setCollective(!isCollective);
            }} 
            className="mb-3"
            disabled={isBooked}
          >
            {t('Collective invoice')}
          </Button>
          {isCollective && (
            <div className="p-4 bg-white border mb-3">
              <Button
                variant="primary"
                className="mb-3"
                disabled={isBooked}
                onClick={() => {
                  if (isBooked) return;
                  if (watch('selectedCustomer')) {
                    setShow((prevState) => {
                      return {
                        ...prevState,
                        showFreelancerSelect: watch('freelancer') ? true : !prevState.showFreelancerSelect,
                      };
                    });
                  } else {
                    selectRef?.current?.focus();
                    setShowTooltipError({
                      NullCustomer: true,
                    });
                    setTimeout(() => {
                      setShowTooltipError({
                        NullCustomer: false,
                      });
                    }, 3000);
                  }
                }}
              >
                {t('Select Freelancers')}
              </Button>
              <div style={{ maxWidth: '900px' }}>
                {show.showFreelancerSelect && (
                  <Controller
                    name="freelancer"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Select
                        isMulti
                        size="lg"
                        {...field}
                        selected={field?.value?.signUpUser?.email}
                        options={freelancers?.map((freelancers) => ({
                          ...freelancers,
                          value: freelancers.userId,
                        }))}
                        getOptionLabel={(option) =>
                          option?.signUpUser?.email +
                          '(' +
                          option?.signUpUser?.firstName +
                          ' ' +
                          option?.signUpUser?.lastName +
                          ')'
                        }
                        closeMenuOnSelect={
                          freelancers?.length - 1 === selectedFreelancers?.length || selectedFreelancers?.length > 13
                        }
                        labelKey="name"
                        components={{ DropdownIndicator, Option }}
                        className="mb-3"
                        id="createInvoiceCustomerSelect"
                        placeholder={t('Select Freelancers')}
                        menuPortalTarget={document.querySelector('body')}
                        isOptionDisabled={() => selectedFreelancers?.length >= 15}
                        onChange={(selectedFreelancer, i) => {
                          handleFreelancerSelect(selectedFreelancer, i);
                        }}
                        noOptionsMessage={({ inputValue }) =>
                          !inputValue ? t('No freelancer found please add to select freelancer') : t('No results found')
                        }
                      />
                    )}
                  />
                )}
              </div>
            </div>
          )}
          <h5 className="heading">2 {t('Specification')}</h5>
          <div className="p-4 bg-white border mb-3">
            <h6>{t('Description')}</h6>
            <p>
              {' '}
              {t(
                'Describe your work in as much detail as you can. This information constitutes the description on the invoice sent to your customer.'
              )}
            </p>
            <textarea
              className="form-control m-0"
              disabled={isBooked}
              {...register('description', {
                required: isBooked ? false : 'Enter at least 3 words or 20 characters',
                maxLength: {
                  value: 1024,
                  message: 'Maximum character limit 1024',
                },
                validate: (value) => {
                  // Skip validation for booked invoices
                  if (isBooked) return true;
                  
                  const wordCount = value?.trim().split(/\s+/).filter(word => word.length > 0).length || 0;
                  if (value.length === 0) {
                    return 'Enter at least 3 words or 20 characters';
                  }
                  if (wordCount < 3 && value.length < 20) {
                    return 'Enter at least 3 words or 20 characters';
                  }
                  const invalidCharactersInDescription = value
                    ?.split("")
                    ?.filter((char) => !INVOICE_DESCRIPTION_ALLOWED_CHARACTERS.test(char));
                  if (invalidCharactersInDescription?.length > 0) {
                    return (`Invalid characters detected: ${invalidCharactersInDescription.join(", ")}`);
                  }
                  return true;
                },
              })}
              onChange={(e) => handleInvoicingDescriptionChange(e, trigger, setValue)}
            />

            {errors?.description?.message && (
              <div>
                {errors.description && (
                  <div className="alert alert-danger mt-3" role="alert">
                    {errors.description?.message}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="col-12 mt-3 p-0 worked-hours">
          <div className="row m-0 bg-secondary-custom px-3 py-4">
            <div className="col p-0">
              <div className="d-flex justify-content-between mb-3 mobile-column worked-hours-div">
                {selectedList?.length > 1 && (
                  <div className="test-btns-div">
                    {selectedList?.map((item, index) => {
                      const isActive = selectedTab.index === index;
                      const firstName = item?.signUpUser?.firstName || item?.name;
                      const lastName = item?.signUpUser?.lastName || '';
                      return (
                        <div key={index} className="single-tag ml-2 mb-2">
                          <Button
                            variant="outline-primary rounded-pill"
                            active={isActive}
                            onClick={() => {setSelectedTab((prev) => ({ ...prev, index }))
                          setArticle({});
                          }
                          }
                          >
                            {`${firstName} ${lastName}`}
                          </Button>
                        </div>
                      );
                    })}
                  </div>

                )}
              </div>
              <p>
                {t('Click on one date and start invoice')}
                <Button className="p-0" onClick={() => setShowReadMore(true)} variant="link" size="sm">
                  {t('Read more')}
                </Button>
              </p>
              {selectedList?.map((item, indexValue) => {
                return (
                  <div key={indexValue}>
                    {selectedTab.index === indexValue && (
                      <>
                        <div className="d-flex calender-list">
                          <OverlayTrigger
                            show={!isBooked && showTooltipError.noDateSelected}
                            placement="top"
                            overlay={
                              <Popover id={`popover-positioned-top`} style={{ margin: 0 }}>
                                <Popover.Header className="text-danger" as="h3">
                                  {selectedTab.index === indexValue &&
                                    showTooltipError.noDateSelected &&
                                    !anyArrayHasValue &&
                                    t('Please Select The date From The Calender')}
                                </Popover.Header>
                              </Popover>
                            }
                          >
                            <div className="Calander-div">
                              <Calender
                                dates={dates}
                                setDates={setDates}
                                className="mb-3 w-100"
                                currentIndex={indexValue}
                                onChange={handleChangeDate}
                                disabled={isBooked}
                              />
                            </div>
                          </OverlayTrigger>
                          <div className="calender-div-data ml-4">
                            <div className="row">
                              <div className="col"></div>
                              <div className="col"></div>
                              {isEditMode && (prefillingData?.getInvoiceData?.fetchInvoices?.dueDate || prefillingData?.getInvoiceData?.dueDate || dueDate) && (
                                <div className="col">
                                  <h6>{('Due date')}</h6>
                                  <input
                                    ref={dueDateInputRef}
                                    type="date"
                                    value={dueDate ? (() => {
                                      const date = new Date(dueDate);
                                      return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
                                    })() : ''}
                                    onChange={(e) => {
                                      setDueDate(e.target.value);
                                    }}
                                    onClick={() => {
                                      if (dueDateInputRef.current) {
                                        dueDateInputRef.current.showPicker();
                                      }
                                    }}
                                    style={{
                                      border: 'none',
                                      background: '#white',
                                      padding: '2px',
                                      fontSize: 'inherit',
                                      fontFamily: 'inherit',
                                      cursor: 'pointer'
                                    }}
                                  />
                                </div>
                              )}
                              {(hasWorkingHours || anyArrayHasValue) && (
                                <>
                                  <div className="col">
                                    <h6>{t('Show Date')}</h6>
                                    <div className="d-flex">
                                      {['Yes', 'No'].map((label, idx) => (
                                        <div className={`form-check ${idx === 1 ? 'ml-3' : ''}`} key={label}>
                                          <input
                                            className="form-check-input cursor-pointer"
                                            type="radio"
                                            id={`showHours${label}`}
                                            value={label === 'Yes'}
                                            disabled={(label === 'No' && rootDeduction) || isBooked}
                                            {...register('showDates')}
                                          />
                                          <label className="form-check-label cursor-pointer" htmlFor={`showHours${label}`}>
                                            {t(label)}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  </div>

                                  <div className="col">
                                    <Button
                                      style={{ textDecoration: 'underline' }}
                                      onClick={async () => {
                                        const validated = await trigger(
                                          ['selectedCustomer', 'description', 'email', 'customCheck', 'amount'],
                                          { shouldFocus: true }
                                        );
                                        if (validated) amountValidation(true);
                                      }}
                                      variant="link"
                                      size="md"
                                    >
                                      {t('Preview Invoice')}
                                    </Button>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="data-set">
                              <div className="overflow mt-3 px-0 mr-2 mb-0">
                                {articles.length > 0 &&
                                  dates[indexValue]?.map((item, index) => {
                                    const dateStr = formatDateStr(item?.date, item?.id);

                                    const dayArticle = watch(`invoiceHours[${indexValue}.[${dateStr}].article]`) || null;
                                    const dateHours = watch(`invoiceHours[${indexValue}.[${dateStr}].units`);
                                    const amountPerHr = watch(`invoiceHours[${indexValue}.[${dateStr}].amount`);

                                    const calcTotal = () => {
                                      if (!(dateHours >= 1 && dateHours <= 24 && amountPerHr)) return 0;

                                      const isOther = dayArticle?.articleNumber === otherCost;
                                      const isSpecial = dayArticle?.articleNumber === 94;

                                      if (isOther && dateHours > 13) return 13 * amountPerHr;
                                      if (isOther && dateHours <= 0) return 0;
                                      if (isSpecial && dateHours > 220) return 220 * amountPerHr;
                                      if (dateHours < 0) return 0;

                                      return dateHours * Math.max(amountPerHr, 0);
                                    };

                                    const total = calcTotal();

                                    return (
                                      <React.Fragment key={index}>
                                        <WorkingHoursRow
                                          {...{
                                            index,
                                            rootDeduction,
                                            rutDeduction,
                                            dayArticle,
                                            dates,
                                            indexValue,
                                            setDates,
                                            setRemoveClickedDate,
                                            dateStr,
                                            handleChangeInvoiceArticle,
                                            showTooltipError,
                                            selectedIndex,
                                            articles,
                                            control,
                                            isFixed,
                                            setShowTooltipError,
                                            register,
                                            currency,
                                            total,
                                            handleChangeAmount,
                                            watch,
                                            setSelectedIndex,
                                            setUnitDateStr,
                                            handleChangeUnit,
                                            setOtherArticlesData,
                                            showDates,
                                            setValue,
                                            article,
                                            setArticle,
                                            vat,
                                            selectedCustomer,
                                            isBooked,
                                            prefillingData,
                                          }}
                                        />
                                      </React.Fragment>
                                    );
                                  })}
                                <OtherArticlesRow
                                  otherArticleValues={otherArticlesData}
                                  isFixed={isFixed}
                                  currency={currency}
                                  setOtherArticleValues={setOtherArticlesData}
                                  showTooltipError={showTooltipError}
                                  setShowTooltipError={setShowTooltipError}
                                  indexValue={indexValue}
                                  calculatedAmounts={calculatedAmounts}
                                  isLoading={spinner}
                                  handleEdit={handleEdit}
                                  setOtherArticlesData={setOtherArticlesData}
                                  selectedTab={selectedTab}
                                  showDates={showDates}
                                  vat={vat}
                                  currencyGlobalValue={currencyGlobalValue}
                                  selectedCustomer={selectedCustomer}
                                  isBooked={isBooked}
                                />
                              </div>
                            </div>
                            <OtherArticlesOptionsUI
                              dates={dates}
                              register={register}
                              watch={watch}
                              setShow={setShow}
                              show={show}
                              setError={setError}
                              setOpenModal={setOtherArticlesUI}
                              indexValue={indexValue}
                              handleSeeCalculations={handleSeeCalculations}
                              setShowSubmit={setShowSubmit}
                              totalHours={totalHours}
                              handleOtherArticleValue={handleOtherArticleValue}
                              otherArticleValues={otherArticlesData}
                              anyArrayHasValue={anyArrayHasValue}
                              hasWorkingHours={hasWorkingHours}
                              setPensionDrop={setPensionDrop}
                              pension={pension}
                              isPensionDrop={isPensionDrop}
                              globalData={globalData}
                              setHolidaySavingDrop={setHolidaySavingDrop}
                              holidaySavings={holidaySavings}
                              isHolidaySavingDrop={isHolidaySavingDrop}
                              setHolidaySavingFee={setHolidaySavingFee}
                              holidaySavingFee={holidaySavingFee}
                              setValue={setValue}
                              pensionAmount={pensionAmount}
                              setPensionAmount={setPensionAmount}
                              seperatedUserCalculations={seperatedUserCalculations}
                              selectedTabcheck={selectedTab}
                              selectedList={selectedList}
                              userDetails={userDetails}
                               pensionOptions={pensionOptions}
                               prefillingData={prefillingData}
                               grossSalary={grossSalary}
                            />
                          </div>
                        </div>

                      </>
                    )}
                  </div>
                );
              })}
              {[0, 1].includes(Number(customer?.accountType)) &&  customer?.country === "Sweden" &&(
                <div className="work-details-col-wrapper mt-3 bg-secondary-custom">
                  <div className="white-box mt-2">
                    <h6>{t('ROT and RUT tax deduction')}</h6>
                    <p>{t('If your invoice relates to a job that entitles your client to claim allowances for home maintenance and repairs, click below.')}</p>

                    <div className="checkbox-wrapper">
                      {['rootDeduction', 'rutDeduction'].map((key, i) => (
                        <div className="form-check d-flex align-items-center mb-2" key={key}>
                          <input
                            id={key}
                            type="checkbox"
                            className="form-check-input cursor-pointer"
                            disabled={isBooked}
                            {...register(key, {
                              value: false,
                              onChange: (e) => {
                                if (isBooked) return;
                                const checked = e.target.checked;
                                if (key === 'rootDeduction' && checked) {
                                  setValue('rutDeduction', false);
                                  setValue('house', false);
                                  setValue('apartment', true);
                                  setValue('showDates', 'true');
                                }
                                if (key === 'rutDeduction' && checked) setValue('rootDeduction', false);
                              },
                            })}
                          />
                          <label htmlFor={key} className="form-check-label pl-2 mt-1 cursor-pointer">
                            {t(`${key === 'rootDeduction' ? 'ROT' : 'RUT'}-deduction`)}
                          </label>
                        </div>
                      ))}

                      {rootDeduction && (
                        <div className="inner-fields">
                          <label className="mt-3 choose">{t('Choose type of accommodation')}</label>

                          {[
                            {
                              key: 'house',
                              label: t('House'),
                              checked: house,
                              onChange: () => {
                                if (isBooked) return;
                                setValue('apartment', false);
                                if (!apartment) setValue('house', true);
                              },
                              fields: house && (
                                <input
                                  type="text"
                                  {...register('rotApartmentNo')}
                                  className="form-control w-50 bg-light my-2"
                                  placeholder={t('Property')}
                                  autoFocus
                                  disabled={isBooked}
                                />
                              ),
                            },
                            {
                              key: 'apartment',
                              label: t('Apartment'),
                              checked: apartment,
                              onChange: () => {
                                if (isBooked) return;
                                setValue('house', false);
                                if (!house) setValue('apartment', true);
                              },
                              fields: apartment && (
                                <>
                                  <input
                                    type="text"
                                    {...register('brfNo')}
                                    placeholder={t('Brf org. number')}
                                    className="form-control w-50 bg-light my-2"
                                    autoFocus
                                    disabled={isBooked}
                                  />
                                  <input
                                    type="text"
                                    {...register('rotApartmentNo')}
                                    placeholder={t('Apartment number')}
                                    className="form-control w-50 bg-light"
                                    disabled={isBooked}
                                  />
                                </>
                              ),
                            },
                          ].map(({ key, label, onChange, checked, fields }) => (
                            <div className="mb-3" key={key}>
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  id={`customCheck-${key}`}
                                  className="custom-control-input cursor-pointer"
                                  disabled={isBooked}
                                  {...register(key, { onChange })}
                                />
                                <label htmlFor={`customCheck-${key}`} className="custom-control-label cursor-pointer">
                                  {label}
                                </label>
                              </div>
                              {fields}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="hsd-link mt-2">
                      <Link to="" className="pointer-link" onClick={() => setShowRootRut(true)}>
                        {t('Read more about ROT- and RUT-deduction')} <BiRightArrowAlt />
                      </Link>
                    </div>
                  </div>
                </div>
              )}

              <div className="row m-0 px-3 py-3 justify-content-between align-items-center bg-primary">
                <div className="col p-0">
                  <p className="text-light m-0">{t('Invoice amount ex. VAT')}</p>
                </div>
                <div className="col-custom d-flex align-items-center ">
                  <div className="form-check d-flex align-items-center mr-2">
                    <input
                      className="form-check-input text-dark"
                      type="checkbox"
                      id="isFixed"
                      data-toggle={isBooked ? "" : "tooltip"}
                      data-placement={isBooked ? "" : "top"}
                      title={
                        !isBooked && !allArticlesHaveNumber92() &&
                        t("All articles must be 'Payment per hour' to enable fixed pricing.")
                      }
                      disabled={!allArticlesHaveNumber92() || rootDeduction || rutDeduction || isBooked}
                      onClick={(event) => {
                        if (isBooked) return;
                        handleChangeFixedPrice(event);
                      }}
                      {...register('isFixed')}
                    />
                    <label className="form-check-label pl-2 mt-1 text-white cursor-pointer" htmlFor="isFixed">
                      {t('Fixed Price')}
                    </label>
                  </div>
                  <div>
                    <AmountInputWithTooltip
                      currency={currency}
                      register={register}
                      watch={watch}
                      anyArrayHasValue={anyArrayHasValue}
                      isFixed={isFixed}
                      showTooltipError={showTooltipError}
                      setShowTooltipError={setShowTooltipError}
                      handleTotalAmountChange={handleTotalAmountChange}
                      amountFieldRegister={amountFieldRegister}
                    />
                  </div>
                </div>
              </div>
              <div className="currency-vat d-flex px-4 py-1 justify-content-between align-items-center bg-secondary-custom mb-3">
                <div className="d-flex align-items-center">
                  {[
                    { label: t('CURRENCY'), name: 'currency', data: globalData?.currencies, valueKey: 'description', defaultVal: 'SEK', showKey: 'showCurrencyDetails' },
                    { label: ('VAT'), name: 'vat', data: globalData?.vat, valueKey: 'globalValue', defaultVal: 25, showKey: 'showVatDetails', isPercent: true },
                  ].map(({ label, name, data, valueKey, defaultVal, showKey, isPercent }) => (
                    <React.Fragment key={name}>
                      <p className={`text-primary-custom text-small font-weight-bold m-0 ${name === 'vat' ? 'ml-2' : ''}`}>{label}:</p>
                      <select
                        className="ml-2 cursor-pointer"
                        disabled={isBooked}
                        style={{
                          opacity: isBooked ? 0.5 : 1,
                          cursor: isBooked ? 'not-allowed' : 'pointer'
                        }}
                        {...register(name, {
                          value: defaultVal,
                          onChange: () => {
                            if (isBooked) return;
                            setShow((prev) => ({ ...prev, [showKey]: true }));
                          },
                        })}
                      >
                        {data?.map((val) => (
                          <option key={val.id} value={val[valueKey]}>
                            {val[valueKey]}{isPercent ? '%' : ''}
                          </option>
                        ))}
                      </select>
                    </React.Fragment>
                  ))}
                </div>

                <div className="text-primary-custom text-small font-weight-bold m-0">
                  {t('INVOICE AMOUNT INC. VAT')}:{' '}
                  {spinner && !expressPayout ? (
                    <div className="spinner-border text-primary-custom spinner-border-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    Math.round(
                      calculatedAmounts?.amountIncludingVat < 0 || amount === ''
                        ? 0
                        : calculatedAmounts?.amountIncludingVat || 0
                    )
                  )}{' '}
                  {currency}
                </div>
              </div>


              <div>
                {errors.amount && (
                  <div className="alert alert-danger" role="alert">
                    {errors.amount.message}
                  </div>
                )}
              </div>
              <div className="float-right">
                <a
                  className="cursor-pointer"
                  onClick={() => {
                    setShow((prevState) => ({
                      ...prevState,
                      showCurrencyDetails: true,
                    }));
                  }}
                >
                  {t('How we calculate the currency rates')}?
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 bg-secondary-custom px-3 py-3 mt-3">
          <div className="row m-0 mb-3 px-3 py-3 justify-content-between align-items-center bg-primary">
            <div className="col p-0">
              <p className="text-light m-0">
                {t('A minimum fee of 190 SEK applies if 1.9% of the invoice amount is lower.')}
              </p>
            </div>
          </div>
          <div className="bg-primary px-4 py-4 d-flex justify-content-between mb-3">
            <p className="m-0 text-white font-weight-bold">{t('Paid to your bank account')}</p>
            <p className="m-0 text-white font-weight-bold">
              SEK {/* {currency} */}{' '}
              {spinner ? (
                <span className="spinner-border text-light spinner-border-sm" role="status">
                  <span className="sr-only">Loading...</span>
                </span>
              ) : amount == 0 ? (
                0
              ) : Math.round(calculatedAmounts?.toPayInSek) ? (
                Math.round(calculatedAmounts?.toPayInSek)
              ) : (
                0
              )}
            </p>
          </div>
          {(hasWorkingHours || anyArrayHasValue) && (
            <p className="text-right text-primary-custom mb-0">
              <a
                className="cursor-pointer"
                onClick={() => {
                  handleSeeCalculations(0);
                  setShowSubmit(false);
                }}
              >
                {t('See how we calculated')}?
              </a>
            </p>
          )}
          <InvoiceOffers
            customer={customer}
            setShowExpressPayment={setShowExpressPayment}
            setValue={setValue}
            watch={watch}
            register={register}
            invoiceImg={invoiceImg}
            isPensionApplicable={isPensionApplicable}
            userDetails={userDetails}
            seperatedUserCalculations={seperatedUserCalculations}
            pension={pension}
            setPensionDrop={setPensionDrop}
            isPensionDrop={isPensionDrop}
            pensionAmount={pensionAmount}
            pensionOptions={pensionOptions}
            holidaySavings={holidaySavings}
            setHolidaySavingDrop={setHolidaySavingDrop}
            isHolidaySavingDrop={isHolidaySavingDrop}
            holidaySavingFee={holidaySavingFee}
            globalData={globalData}
            setHolidaySavingFee={setHolidaySavingFee}
            setPensionAmount={setPensionAmount}
            setSeperatedUserCalculations={setSeperatedUserCalculations}
            selectedTab={selectedTab}
            selectedList={selectedList}
          />

          <Button
            className="mb-2 p-0"
            onClick={async () => {
              const validated = await trigger(['selectedCustomer', 'description', 'email', 'customCheck', 'amount'], {
                shouldFocus: true,
              });
              if (validated) {
                amountValidation(true);
              }
            }}
            variant="link"
            size="sm"
          >
            {t('See invoice that will be sent to customer')}
          </Button>
          <div>
            {errors.customCheck && (
              <div className="alert alert-danger" role="alert">
                {errors.customCheck.message}
              </div>
            )}
          </div>
          <div className="mt-3">
            <CloseInvoiceToolModal
              show={showModal}
              onHide={() => setShowModal(false)}
              closeInvoiceTool={closeInvoiceTool}
            />
            <Button onClick={() => setShowModal(true)} variant="outline-primary" size="md" className="bg-light">
              {t('Cancel')}
            </Button>
            <Button variant="primary" type="submit" className="ml-3 text-light filled orange" size="md">
              {t('Complete billing')}
            </Button>
          </div>
        </div>
      </form>
      {showDialog && (
        <EditCustomerDialog
          title={t('Add new Customer')}
          show={true}
          onClose={() => setShowDialog(null)}
          onSubmit={addNewCustomer}
          paymentTerms={globalData.paymentTerms}
          globalData={globalData}
        />
      )}
      {show.show && (
        <EditCustomerDialog
          title={'Edit Customer'}
          show={true}
          onClose={() =>
            setShow({
              ...show,
              show: false,
            })
          }
          onSubmit={onEditCustomer}
          globalData={globalData}
          paymentTerms={globalData.paymentTerms}
          customer={{
            postAddress: customer?.postAddress,
            postCity: customer?.postCity,
            postCountry: customer?.postCountry,
            postZipCode: customer?.postZipCode,
            postCountryCode : customer?.postCountryCode,
            name: customer?.name,
            orgNo: customer?.orgNo,
            ssn: customer?.ssn,
            phoneNumber: customer?.phoneNumber,
            reference: customer?.reference,
            email: customer?.email,
            secondaryEmailAddress: customer?.secondaryEmailAddress,
            address: customer?.address,
            address2: customer?.address2,
            co: customer?.co,
            city: customer?.city,
            zipCode: customer?.zipCode,
            isVATRegistred: customer?.isVATRegistred,
            country: customer?.country,
            paymentTerm: customer?.paymentTerm,
            accountType: customer?.accountType,
            isSecondaryEmailAddress: customer?.isSecondaryEmailAddress,
            secondaryEmailAddress: customer?.secondaryEmailAddress,
            vatNumber: customer?.vatNumber,
            invoiceType: customer?.customerAddress ? customer?.customerAddress?.[0]?.invoiceType : customer?.invoiceType,
            yourElectronicReference: customer?.customerAddress ? customer?.customerAddress?.[0]?.yourElectronicReference : customer?.yourElectronicReference,
            extraField1: customer?.customerAddress ? customer?.customerAddress?.[0]?.extraField1 : customer?.extraField1,
            extraField2: customer?.customerAddress ? customer?.customerAddress?.[0]?.extraField2 : customer?.extraField2,
            globalLocationNumber: customer?.customerAddress ? customer?.customerAddress?.[0]?.globalLocationNumber : customer?.globalLocationNumber,
          }}
        />
      )}
      {showInvoice && (
        <ShowInvoiceDialog
          show={true}
          selectedFreelancers={selectedFreelancers}
          onClose={() => setShowInvoice(false)}
          customer={customer}
          globalData={globalData}
          formValues={getValues()}
          calculatedAmounts={calculatedAmounts}
          currency={currency}
          user={userDetails}
          file={combineprefillInvoiceFileData}
          otherArticleValues={otherArticlesData}
          createdDate={prefillingData?.getInvoiceData?.fetchInvoices?.createdDate}
          anyArrayHasValue={anyArrayHasValue}
          getOtherArticlesUnit={getOtherArticlesUnit}
          totalHours={totalHours}
          getPdfUrl={show?.PDFData}
          allowancePerDay={allowancePerDay}
          allowancePerDaySweden={allowancePerDaySweden}
          currencyGlobalValue={currencyGlobalValue}
        />
      )}

      <HowCalculatedModal
        t={t}
        show={show}
        setShow={setShow}
        currency={currency}
        calculatedAmounts={calculatedAmounts}
        otherArticlesData={otherArticlesData}
        seperatedUserCalculations={seperatedUserCalculations}
        selectedList={selectedList}
        isSeparatelyShown={isSeparatelyShown}
        setIsSeparatelyShown={setIsSeparatelyShown}
        userInvoiceData={userInvoiceData}
        customer={customer?.customerAddress ? customer?.customerAddress?.[0] : customer}
      formValues={getValues()}
       setGrossSalary={setGrossSalary}
         grossSalary={grossSalary}
     />

      {showSubmit && (
        <InvoiceSummaryModal
          show={showSubmit}
          onHide={() => setShowSubmit(false)}
          customer={customer}
          currency={currency}
          amount={amount}
          searchParams={searchParams}
          updateInvoices={handleUpdateInvoices}
          createInvoice={createInvoice}
          getValues={getValues}
          setStoredValues={setStoredValues}
          otherArticlesData={otherArticlesData}
        />
      )}
      {invoiceNumber && (
        <InvoiceCreatedModal
          t={t}
          setInvoiceNumber={setInvoiceNumber}
          setDates={setDates}
          setCalculatedAmounts={setCalculatedAmounts}
          setCustomer={setCustomer}
          reset={reset}
          navigate={navigate}
        />
      )}
      {showReadMore && (
        <WorkingTimeInfoModal show={true} onHide={() => setShowReadMore(false)} />
      )}
      {showWorkDatesNotification && (
        <WorkDatesNotificationModal show={true} onHide={() => setShowWorkDatesNotification(false)} onClick={() => {
          removeUnapprovedDate();
        }} />
      )}
      <CurrencyDetailsModal show={show} setShow={setShow} t={t} />
      <VatDetailsModal show={show} setShow={setShow} t={t} />
      {showRootRut && (
        <RootRutModal show={true} onHide={() => setShowRootRut(false)} />
      )}
      {showAgreement && (
        <AgreementModal show={true} onHide={() => setShowAgreement(false)} />
      )}

      {showExpressPayment && (
        <ExpressPaymentModal show={true} onHide={() => setShowExpressPayment(false)} />
      )}

      {otherArticlesUI?.show && (
        <OtherArticlesForm
          t={t}
          openModal={otherArticlesUI}
          setOpenModal={setOtherArticlesUI}
          onSubmitArticleForm={onSubmitArticleForm}
          onEditArticleForm={onEditArticleForm}
          currency={currency}
          countries={countriesList}
          allowancePerDay={allowancePerDay}
          setAllowancePerDay={setAllowancePerDay}
          allowancePerDaySweden={allowancePerDaySweden}
          setAllowancePerDaySweden={setAllowancePerDaySweden}
          currencyGlobalValue={currencyGlobalValue}
          selectedCustomer={selectedCustomer}
        />
      )}
      {invoiceDetails && (
        <EditInvoiceModal
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          invoiceNumber={location.state?.invoiceNumber}
          invoiceDetails={invoiceDetails}
          getValues={storedValues}
          prefillingData={prefillingData}

        />
      )}
    </div>
  );
};

export default InvoiceTool;
